module.exports = __webpack_public_path__ + "img/creator_icon.e680b8dd.svg";